import React, { useRef } from "react";
import {
  WorkflowModalBody,
  WorkflowModalFooter,
  WorkflowModalHeader,
  WorkflowModalShell,
} from "../workflow/WorkflowModal";
import { ReadableNavButton } from "../Sticker";

export default function NotifyAfterSaveDialog({ open, onYes, onNo }) {
  const dialogRef = useRef(null);

  if (!open) return null;

  return (
    <WorkflowModalShell
      dialogRef={dialogRef}
      onClose={onNo}
      testId="notify-after-save-dialog"
      titleId="notify-after-save-title"
      maxWidthClass="sm:max-w-[480px]"
    >
      <WorkflowModalHeader
        title="Notify attendees?"
        titleId="notify-after-save-title"
        onClose={onNo}
        closeTestId="notify-after-save-close"
        align="center"
      />
      <WorkflowModalBody className="text-center">
        <p className="font-ui font-medium text-[15px] text-ink/80 leading-relaxed">
          Would you like to notify attendees about these changes?
        </p>
      </WorkflowModalBody>
      <WorkflowModalFooter className="flex flex-col sm:flex-row gap-2 justify-center">
        <ReadableNavButton
          type="button"
          variant="primary"
          onClick={onYes}
          className="w-full sm:w-auto"
          data-testid="notify-after-save-yes"
        >
          Yes
        </ReadableNavButton>
        <ReadableNavButton
          type="button"
          onClick={onNo}
          className="w-full sm:w-auto"
          data-testid="notify-after-save-no"
        >
          No
        </ReadableNavButton>
      </WorkflowModalFooter>
    </WorkflowModalShell>
  );
}
